import { Link, useParams } from 'react-router-dom'

import Nav from 'react-bootstrap/Nav'

export default function ConfigTemplateNav({ activeKey }) {

    const { beId, configTemplateId } = useParams()

    return (
        <Nav variant="tabs" size="sm" activeKey={activeKey} className="px-3 my-3">
            <Nav.Item>
                <Link className={"nav-link".concat(activeKey == "1" ? " active" : "")} eventkey="1" to={`/be/${beId}/templates/${configTemplateId}`}>Manual</Link>
            </Nav.Item>
            <Nav.Item>
                <Link className={"nav-link".concat(activeKey == "2" ? " active" : "")} eventkey="2" to={`/be/${beId}/templates/${configTemplateId}/config`}>Visual Editor</Link>
            </Nav.Item>
        </Nav>
    )
}

export function ConfigTemplateSubNav({ activeKey }) {

    const { beId, configTemplateId } = useParams()

    return (
        <Nav variant="pills" size="sm" activeKey={activeKey} className="px-4 mb-3">
            <Nav.Item>
                <Link className={"nav-link".concat(activeKey == "2" ? " active" : "")} eventkey="2" to={`/be/${beId}/templates/${configTemplateId}/config`}>Configuration</Link>
            </Nav.Item>
            <Nav.Item>
                <Link className={"nav-link".concat(activeKey == "3" ? " active" : "")} eventkey="3" to={`/be/${beId}/templates/${configTemplateId}/apiinterfaces`}>API Interfaces</Link>
            </Nav.Item>
            <Nav.Item>
                <Link className={"nav-link".concat(activeKey == "4" ? " active" : "")} eventkey="4" to={`/be/${beId}/templates/${configTemplateId}/devices`}>Devices</Link>
            </Nav.Item>
        </Nav>
    )
}
